import { craftRoleListSchema, type CraftRole, type CraftRoleList } from '@tailoring-crm/shared';
import type { ApiClient } from '../api/client.js';

/**
 * The shop's craft roles, over HTTP.
 *
 * Lives beside the staff client rather than with the settings screens because the staff screens
 * are what read it: the roster filter and the profile picker both need to know what this shop
 * calls its trades. Editing the list is an API-only surface for now (there is no settings screen
 * for it yet), so only the read is here.
 *
 * A craft role is a LABEL. Nothing the app does with this list decides what anybody may see or
 * do — that comes from the auth role on the session, and from nowhere else.
 */

const PATH = '/settings/craft-roles';

export async function getCraftRoles(client: ApiClient): Promise<CraftRoleList> {
  return await client.get(PATH, { schema: craftRoleListSchema });
}

/** The ones a picker or filter may offer: a retired trade is still resolvable, never offered. */
export function offerableCraftRoles(roles: readonly CraftRole[] | undefined): CraftRole[] {
  return (roles ?? []).filter((role) => role.active);
}
